import  ListNotification  from './list-notification.component'

export default ListNotification
